import { render, staticRenderFns } from "./editSku.vue?vue&type=template&id=ecbd4dec&scoped=true&"
import script from "./editSku.vue?vue&type=script&lang=js&"
export * from "./editSku.vue?vue&type=script&lang=js&"
import style0 from "./editSku.vue?vue&type=style&index=0&id=ecbd4dec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbd4dec",
  null
  
)

export default component.exports